import React from "react";
import PropTypes from "prop-types";
import { toogleShareBox } from "../../Utils/DOM-Manipulation";

const WhatsApp = (props = {}) => {
  const { darkMode, colors, size, className, setOpen, isMobile, action, link } =
    props;

  return (
    <svg
      className={className}
      width={size.width}
      height={size.height}
      onClick={() => {
        action(link);
        isMobile ? setOpen(false) : toogleShareBox(isMobile);
      }}
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="wapp">
        <path
          id="Subtract"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M383.796 512C454.246 512 512 453.837 512 383.386V127.796C512 56.9344 454.246 0 383.796 0H128.205C57.7536 0 0 57.3441 0 127.796V383.386C0 453.837 57.7536 512 128.205 512H383.796ZM258.867 407.239C345.702 407.239 415.743 337.607 415.743 251.591C415.743 165.575 345.702 95.9426 258.867 95.9426C172.032 95.9426 101.99 165.575 101.99 251.591C101.99 281.082 110.182 308.525 124.518 331.873L96.2554 415.431L183.09 387.987C205.618 400.275 231.423 407.239 258.867 407.239ZM126.975 251.181C126.975 179.091 185.958 120.519 258.867 120.519C331.776 120.519 390.758 179.501 390.758 251.591C390.758 323.68 331.776 382.253 258.867 382.253C232.242 382.253 207.257 374.061 186.368 360.544L135.577 376.519L151.961 327.777C136.397 306.478 126.975 279.854 126.975 251.181ZM333.742 284.352C335.833 285.365 337.358 286.103 337.919 287.226C339.148 288.864 339.148 296.647 335.053 306.478C331.776 315.488 316.21 323.68 309.248 324.499C308.022 324.636 307.001 324.885 305.97 325.137C300.8 326.398 295.408 327.715 262.963 315.079C227.897 301.052 204.473 267.401 198.686 259.087C198.052 258.176 197.629 257.569 197.427 257.326C197.295 257.128 197.083 256.829 196.806 256.438C193.637 251.962 181.861 235.329 181.861 218.004C181.861 199.543 191.299 190.126 195.148 186.286C195.227 186.206 195.304 186.129 195.378 186.055C199.065 181.959 203.161 181.14 205.618 181.14C206.903 181.14 208.3 181.252 209.634 181.359C210.851 181.456 212.014 181.55 212.992 181.55C213.275 181.55 213.582 181.518 213.909 181.485C215.946 181.276 218.77 180.988 221.593 187.693C222.32 189.421 223.27 191.673 224.316 194.154C227.982 202.851 232.834 214.362 233.472 215.955C234.701 217.594 235.11 220.052 233.881 222.509C233.663 223.016 233.472 223.485 233.292 223.924C232.456 225.969 231.88 227.377 230.194 229.062C229.115 230.142 228.035 231.45 227.016 232.685C226.101 233.792 225.235 234.842 224.46 235.616C222.413 237.664 220.774 239.712 222.822 243.399C224.87 247.085 232.652 259.373 244.121 269.614C255.808 280.002 266.209 284.472 271.856 286.9C273.334 287.535 274.486 288.03 275.251 288.455C278.937 290.503 281.394 290.093 283.443 287.635L283.47 287.604C285.954 284.705 293.282 276.154 295.731 272.48C298.188 268.385 301.055 269.204 304.332 270.433C307.609 271.661 326.86 280.673 330.546 282.721C331.706 283.365 332.784 283.887 333.742 284.352Z"
          fill={!darkMode ? colors.dark : colors.light}
        />
      </g>
    </svg>
  );
};

WhatsApp.propTypes = {
  props: PropTypes.shape({
    darkMode: PropTypes.bool,
    colors: PropTypes.objectOf(PropTypes.string),
    size: PropTypes.objectOf(PropTypes.string),
    className: PropTypes.string,
    setOpen: PropTypes.func,
    isMobile: PropTypes.bool,
    action: PropTypes.func,
    link: PropTypes.string,
  }),
};

export default WhatsApp;
